import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNavbar.css';

const BottomNavbar = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);
  const [indicatorPosition, setIndicatorPosition] = useState(0); // Added state to store indicator position

  useEffect(() => {
    const activeElement = document.querySelector('.list .active');
    if (activeElement) {
      const activeIndex = Array.from(activeElement.parentElement.children).indexOf(activeElement);
      setIndicatorPosition(activeIndex);
    }
  }, [activeLink]);

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const listItems = document.querySelectorAll('.list li');
      if (!event.target.closest('.list')) {
        listItems.forEach((item) => {
          item.classList.remove('active');
        });
        setIndicatorPosition(-1); // Hide the indicator when clicking outside
      }
    };

    document.body.addEventListener('click', handleClickOutside);

    return () => {
      document.body.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <nav className="footer-container">
      <ul className="list">
      <li>
          {/* Indicator */}
          <div style={{ '--position': indicatorPosition}} className="indicator">
            <div className="corners"></div>
          </div>
        </li>
        {/* List items */}
        <li className={activeLink === '/AboutUs' ? 'active' : ''}>
        <Link to="/AboutUs" onClick={() => handleLinkClick('/AboutUs')}>
            <div className="icon">
              {/* SVG icon for About Us */}
              <svg viewBox="0 0 24 24">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 16h-2v-6h2v6zm0-8h-2V7h2v3z"/>
              </svg>
            </div>
            <div className="text">About Us</div>
          </Link>
        </li>
        <li className={activeLink === '/governance' ? 'active' : ''}>
        <Link to="/governance" onClick={() => handleLinkClick('/governance')}>
            <div className="icon">
                            <svg fill="#000000" viewBox="0 0 297.891 297.891">
              <g>
         <path d="M264.148,40.644L153.978,0.89C152.334,0.297,150.64,0,148.917,0c-1.731,0-3.449,0.3-5.101,0.899L34.041,40.653
             c-5.933,2.152-10.096,7.789-10.096,14.101v94.191c0,21.029,6.778,42.061,19.713,62.51c9.915,15.673,23.715,31.043,40.802,45.686
             c28.57,24.482,56.918,38.604,58.109,39.193c2.096,1.037,4.402,1.557,6.681,1.557c2.245,0,4.505-0.504,6.577-1.512
             c1.191-0.58,29.526-14.482,58.123-38.867c17.104-14.584,30.697-29.954,40.619-45.682c12.93-20.493,19.375-41.65,19.375-62.885
             V54.754C273.945,48.432,270.095,42.788,264.148,40.644z M47.945,148.875V65.969c0-3.156,1.934-5.975,4.901-7.051l93.312-33.947
             c0.832-0.301,1.787-0.523,2.787-0.523v124.498h101.711c0.006,0,0.013,0.135,0.013,0.221c-0.02,27.129-13.684,54.016-40.607,80.195
             c-21.025,20.445-44.912,35.036-57.199,41.919c-1.139,0.639-2.917,0.94-3.917,0.94c0-2.333,0-121.982,0-123.314L47.945,148.875z"/>
     </g>
              </svg>
            </div>
            <div className="text">Governance</div>
          </Link>
        </li>
        <li className={activeLink === '/volunteer' ? 'active' : ''}>
        <Link to="/volunteer" onClick={() => handleLinkClick('/volunteer')}>
            <div className="icon">
                            <svg fill="#000000" viewBox="0 0 50 50">
              <g id="Solid">
            <path d="M46.79248,24.23a4.05389,4.05389,0,0,0-5.689-.14l-7.69872,6.84a5.25608,5.25608,0,0,1,.58993,2.43,5.39055,5.39055,0,0,1-3.4794,5.02l-6.46895,2.43a1.00694,1.00694,0,0,1-1.27975-.59.98322.98322,0,0,1,.57986-1.28l6.46895-2.43A3.38021,3.38021,0,0,0,31.995,33.36,3.45753,3.45753,0,0,0,28.63555,30H9.99866A1.99982,1.99982,0,0,0,7.999,28H3.99966A1.99982,1.99982,0,0,0,2,30V46a1.99986,1.99986,0,0,0,1.99966,2H7.999a1.99986,1.99986,0,0,0,1.99967-2H14.048l1.24979.51A19.61328,19.61328,0,0,0,37.924,40.87l9.10846-11.01A4.20182,4.20182,0,0,0,46.79248,24.23ZM12.99816,44H9.99866V32h2.9995ZM30.41809,2a8.59142,8.59142,0,0,0-5.42194,1.9082A8.59147,8.59147,0,0,0,19.5742,2a8.68822,8.68822,0,0,0-8.66651,8.68945c0,9.14258,13.03,16.85059,13.58463,17.17481a1.00289,1.00289,0,0,0,1.00765,0C26.05456,27.54,39.08461,19.832,39.08461,10.68945A8.68822,8.68822,0,0,0,30.41809,2Zm-1.772,18.6571a.98319.98319,0,0,1-.65022.2229.99554.99554,0,0,1-.65047-1.7423c3.70153-3.1709,5.74025-6.17188,5.74025-8.44825A2.68158,2.68158,0,0,0,30.41809,8a1,1,0,0,1,0-2,4.68337,4.68337,0,0,1,4.66719,4.68945C35.08528,14.3681,31.584,18.13953,28.64605,20.6571Z"/>
            </g>
              </svg>
            </div>
            <div className="text">Volunteer</div>
          </Link>
        </li>
        <li className={activeLink === '/Projects' ? 'active' : ''}>
        <Link to="/Projects" onClick={() => handleLinkClick('/Projects')}>
            <div className="icon">
                    <svg fill="#000000"  viewBox="0 0 64 64">
      <g id="hammer">
                <path d="M30.651,23.538l25.24,24.346l-6.577,6.577l-23.969,-25.617l5.306,-5.306Zm-7.208,3.403l5.306,-5.305c0,0 -2.695,-2.056 -2.447,-3.34c0.248,-1.285 0.809,-3.1 4.711,-4.711c3.903,-1.611 7.543,-1.757 7.543,-1.757l0.131,-1.758c0,0 -8.969,-1.356 -13.707,0.327c-4.738,1.684 -10.097,8.02 -10.097,8.02c0,0 0.935,3.064 -0.667,4.666c-1.601,1.601 -3.754,-0.245 -3.754,-0.245l-2.456,3.118l6.197,6.197l3.112,-2.461c0,0 -1.472,-2.207 -0.017,-3.528c3.132,-2.842 6.145,0.777 6.145,0.777Z"/>
            </g>
      </svg>
            </div>
            <div className="text">Projects</div>
          </Link>
        </li>
        <li className={activeLink === '/DonateUs' ? 'active' : ''}>
        <Link to="/DonateUs" onClick={() => handleLinkClick('/DonateUs')}>
            <div className="icon">
                            <svg fill="#000000" viewBox="0 0 1024 1024">
                <path d="M640.172 171.124c119.859 14.637 199.51 49.612 199.51 76.982 0 15.683-30.577 37.475-87.407 54.605-62.809 18.932-148.567 29.865-240.273 29.865-91.711 0-177.469-10.933-240.277-29.865-56.827-17.13-87.403-38.921-87.403-54.605 0-29.366 89.458-66.158 219.676-79.227 11.254-1.13 19.462-11.169 18.332-22.423s-11.169-19.462-22.423-18.332c-151.876 15.243-256.546 58.29-256.546 119.982 0 75.871 164.41 125.43 368.64 125.43 204.223 0 368.64-49.559 368.64-125.43 0-58.893-94.601-100.433-235.505-117.64-11.227-1.371-21.44 6.619-22.812 17.846s6.619 21.44 17.846 22.812zm199.27 725.213c0 40.635-147.078 85.422-327.291 85.422S184.86 936.972 184.86 896.337c0-.463.028-.955.086-1.491 1.218-11.245-6.91-21.348-18.155-22.567s-21.348 6.91-22.567 18.155a54.641 54.641 0 00-.324 5.902c0 76.346 164.316 126.382 368.251 126.382s368.251-50.036 368.251-126.382c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48z"/><path d="M143.697 253.367v646.461c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V253.367c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48zm695.917 0v646.461c0 11.311 9.169 20.48 20.48 20.48s20.48-9.169 20.48-20.48V253.367c0-11.311-9.169-20.48-20.48-20.48s-20.48 9.169-20.48 20.48zm-155.482-4.616c3.451 13.322-7.557 24.218-24.453 24.218h-267.94c-16.896 0-27.894-10.895-24.443-24.218 3.441-13.322 20.091-24.218 36.987-24.218h242.862c16.896 0 33.536 10.895 36.987 24.218z"/><path d="M610.493 117.674c-6.258-38.164-37.244-69.15-75.408-75.408a92.68 92.68 0 00-107.066 107.067c6.258 38.163 37.244 69.149 75.408 75.407a92.682 92.682 0 00107.066-107.066zm40.42-6.629c14.954 91.175-62.939 169.069-154.115 154.115-55.512-9.102-100.097-53.687-109.199-109.196C372.632 64.789 450.535-13.109 541.713 1.846c55.512 9.102 100.097 53.687 109.2 109.2zm20.256 427.849c47.893 47.893 47.893 125.538 0 173.419L544.774 838.708c-17.963 17.982-47.121 17.982-65.077.007L353.296 712.314c-47.895-47.883-47.895-125.527-.004-173.419 43.311-43.322 110.971-47.458 158.939-12.411 47.968-35.047 115.628-30.911 158.937 12.41zM497.75 567.857c-31.897-31.897-83.604-31.897-115.493 0-31.897 31.897-31.897 83.604 0 115.493l126.41 126.41a5.048 5.048 0 007.136-.007l126.404-126.404c31.895-31.887 31.895-83.594-.004-115.493-31.887-31.895-83.594-31.895-115.491.002-7.998 7.998-20.965 7.998-28.963 0z"/>
              </svg>
            </div>
            <div className="text">Donate</div>
          </Link>
        </li>
        <li className={activeLink === '/contact' ? 'active' : ''}>
        <Link to="/contact" onClick={() => handleLinkClick('/contact')}>
            <div className="icon">
                  <svg fill="#000000" height="800px" width="800px" version="1.1" id="Capa_1" viewBox="0 0 75.294 75.294">
<g>
	<path d="M66.097,12.089h-56.9C4.126,12.089,0,16.215,0,21.286v32.722c0,5.071,4.126,9.197,9.197,9.197h56.9
		c5.071,0,9.197-4.126,9.197-9.197V21.287C75.295,16.215,71.169,12.089,66.097,12.089z M61.603,18.089L37.647,33.523L13.691,18.089
		H61.603z M66.097,57.206h-56.9C7.434,57.206,6,55.771,6,54.009V21.457l29.796,19.16c0.04,0.025,0.083,0.042,0.124,0.065
		c0.043,0.024,0.087,0.047,0.131,0.069c0.231,0.119,0.469,0.215,0.712,0.278c0.025,0.007,0.05,0.01,0.075,0.016
		c0.267,0.063,0.537,0.102,0.807,0.102c0.001,0,0.002,0,0.002,0c0.002,0,0.003,0,0.004,0c0.27,0,0.54-0.038,0.807-0.102
		c0.025-0.006,0.05-0.009,0.075-0.016c0.243-0.063,0.48-0.159,0.712-0.278c0.044-0.022,0.088-0.045,0.131-0.069
		c0.041-0.023,0.084-0.04,0.124-0.065l29.796-19.16v32.551C69.295,55.771,67.86,57.206,66.097,57.206z"/>
</g>
</svg>
            </div>
            <div className="text">Contact</div>
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default BottomNavbar;
